import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Temps actif (contrôle Direction, 14/10/2026) : un signal par minute tant que la page est visible ET utilisée
 *  (clic, frappe, défilement ou toucher dans la dernière minute). Silencieux : aucune erreur affichée. */
export default function PresencePing() {
  const { user } = useAuth();
  const derniereAction = useRef(Date.now());
  useEffect(() => {
    if (!user) return undefined;
    const marquer = () => { derniereAction.current = Date.now(); };
    const evts = ['pointerdown', 'keydown', 'scroll', 'touchstart'];
    evts.forEach((e) => window.addEventListener(e, marquer, { passive: true }));
    const appareil = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'téléphone' : 'ordinateur';
    const id = setInterval(() => {
      if (document.visibilityState !== 'visible' || Date.now() - derniereAction.current > 60000) return;
      axios.post(`${API_URL}/api/presence/signal`, { ecran: window.location.pathname, appareil }, { withCredentials: true }).catch(() => {});
    }, 60000);
    return () => { clearInterval(id); evts.forEach((e) => window.removeEventListener(e, marquer)); };
  }, [user]);
  return null;
}
